export const forms = {
  getBaseForm(formData, extend) {
    const data = [
      {
        type: 'text',
        label: '活动报告',
        col: '24',
        name: 'activeReport',
        id: 'activeReport',
        layout: {
          labelCol: '120px'
        }
      }
      // {
      //   type: extend.checkDisplay('activeUpload') ? 'textarea' : 'text',
      //   label: extend.checkDisplay('activeUpload') ? '' : '活动报告',
      //   col: '24',
      //   defaultValue: '带你玩看到你玩奋斗为非农我未返回围殴妇女那刺耳复活你披违法和你玩佩服你和 金访问哦发鸟我而烦恼沃尔芬你分我能否为妇女节佛尔我姐夫我没飞机发奇偶为房间我诶防具凤沃尔夫那欧文范围内',
      //   id: 'activityConfirmation',
      //   layout: {
      //     labelCol: '120px'
      //   },
      //   autoSize: { minRows: 5, maxRows: 6 }
      // }
    ]
    // const newData = []
    // for (let i = 0; i < data.length; i++) {
    //   if (extend.checkDisplay(data[i].id)) {
    //     newData.push(data[i])
    //   }
    // }
    return data
  }
}
